import { useMemo } from 'react';
import OptionsRangeFilter, { FilterOption } from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';

interface ThirdPartyPaymentFilterProps {
  /** undefined = no filtering, true = third-party only, false = ordinary requests only. */
  value: boolean | undefined;
  onChange: (value: boolean | undefined) => void;
}

/**
 * Picks out requests whose money goes to someone other than the beneficiary (HAT-1259).
 *
 * This is the gap the item was opened over: the office had no way of telling these requests apart,
 * because they were handled on paper and never reached the system at all.
 */
const ThirdPartyPaymentFilter = ({ value, onChange }: ThirdPartyPaymentFilterProps) => {
  const options: FilterOption[] = useMemo(() => [
    { id: 'thirdParty', label: 'thirdPartyPayment.filterOnly', checked: value === true },
    { id: 'regular', label: 'thirdPartyPayment.filterExclude', checked: value === false },
  ], [value]);

  const handleOptionChange = (optionId: string) => {
    // The two options are opposites, so ticking one clears the other and re-ticking the active
    // one clears the filter entirely - "both" and "neither" mean the same thing here.
    const picked = optionId === 'thirdParty';
    onChange(value === picked ? undefined : picked);
  };

  return (
    <OptionsRangeFilter
      title="thirdPartyPayment.filterTitle"
      filterType="options"
      options={options}
      onOptionChange={handleOptionChange}
      selectionType="checkbox"
    />
  );
};

export default ThirdPartyPaymentFilter;
